/**
 * Enum of program categories.
 */
export enum EventCategory {
  All = 0,
  FitTest = 1,
  MedicalClearance = 2,
  Training = 3
}
